<template>
  <div>
    <EmdFormGroup
      :label="$t('recipients.create.name')"
      required
      :state="getState($v.recipient.name)"
      :feedbacks="feedbacks($v.recipient.name)"
    >
      <EmdInput
        @input="$v.recipient.name.$touch"
        v-model="recipient.name"
        name="recipient_name"
        :readonly="disabled"
        :disabled="disabled"
        v-if="canEdit"
      />
      <span v-else>{{ recipient.name }}</span>
    </EmdFormGroup>
  </div>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { personalUser } from '../validations'
export default {
  name: 'NameInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    name: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  validations () {
    return { recipient: personalUser }
  }
}
</script>
